import styled from "styled-components";
import { Container } from "../../atoms/GridSystem";

export const PostContent = styled(Container)`
  padding-bottom: ${({ theme }) => theme.rem(40)};
`
